function compareTimes(end: Date, start: Date = new Date()): number {
    const seconds: number = (end.getTime() - start.getTime()) / 1000;
    return seconds;
}

export default compareTimes;
